! function(e) {
    "object" == typeof module && "object" == typeof module.exports ? e(require("jquery"), window, document) : e(jQuery, window, document)
}(function(R, D, M) {
    "use strict";
    var z = R("<div/>").attr("class", "imagelightbox-loading").append(R("<div/>")),
        e = R("<button/>", {
            type: "button",
            class: "imagelightbox-arrow imagelightbox-arrow-left"
        }),
        t = R("<button/>", {
            type: "button",
            class: "imagelightbox-arrow imagelightbox-arrow-right"
        }),
        X = e.add(t),
        j = R("<div/>", {
            class: "imagelightbox-caption",
            html: "&nbsp;"
        }),
        N = R("<a/>", {
            class: "imagelightbox-close"
        }),
        U = R("<div/>", {
            class: "imagelightbox-overlay"
        }),
        K = R("<a/>", {
            href: "#",
            class: "imagelightbox-navitem"
        }),
        Y = R("<div/>", {
            class: "imagelightbox-nav"
        }),
        _ = R("<div/>", {
            class: "imagelightbox-wrapper"
        }),
        $ = R("body"),
        o = function() {
            var e = M.body || M.documentElement;
            return "" === (e = e.style).WebkitTransition ? "-webkit-" : "" === e.MozTransition ? "-moz-" : "" === e.OTransition ? "-o-" : "" === e.transition && ""
        },
        B = !1 !== o(),
        H = function(e, t, i) {
            var n = {},
                a = o();
            n[a + "transform"] = "translateX(" + t + ") translateY(-50%)", n[a + "transition"] = a + "transform " + i + "s linear", e.css(n)
        },
        Q = "ontouchstart" in D,
        W = D.navigator.pointerEnabled || D.navigator.msPointerEnabled,
        A = function(e) {
            if (Q) return !0;
            if (!W || void 0 === e || void 0 === e.pointerType) return !1;
            if (void 0 !== e.MSPOINTER_TYPE_MOUSE) {
                if (e.MSPOINTER_TYPE_MOUSE !== e.pointerType) return !0
            } else if ("mouse" !== e.pointerType) return !0;
            return !1
        },
        G = !1 != !!(M.fullscreenEnabled || M.webkitFullscreenEnabled || M.mozFullScreenEnabled || M.msFullscreenEnabled),
        J = !(!D.history || !history.pushState);
    R.fn.imageLightbox = function(e) {
        var i = "",
            r = R([]),
            l = R(),
            c = -1,
            s = R(this),
            u = R(),
            g = 0,
            f = 0,
            o = 0,
            p = !1,
            n = 0,
            d = R.extend({
                selector: "a[data-imagelightbox]",
                id: "imagelightbox",
                allowedTypes: "png|jpg|jpeg|gif",
                animationSpeed: 250,
                activity: !1,
                arrows: !1,
                button: !1,
                caption: !1,
                enableKeyboard: !0,
                history: !1,
                fullscreen: !1,
                gutter: 10,
                offsetY: 0,
                navigation: !1,
                overlay: !1,
                preloadNext: !0,
                quitOnEnd: !1,
                quitOnImgClick: !1,
                quitOnDocClick: !0,
                quitOnEscKey: !0
            }, e),
            h = function() {
                d.activity && w(), d.arrows && X.css("display", "block")
            },
            a = function(e, t, i) {
                var n = t + "=" + i,
                    a = "?" + n;
                if (e) {
                    var o = new RegExp("([?&])" + t + "=[^&]*");
                    a = null !== e.match(o) ? e.replace(o, "$1" + n) : e + "&" + n
                }
                return a
            },
            b = function() {
                if (J && d.history) {
                    var e = r[c].dataset.ilb2Id;
                    e || (e = c);
                    var t = {
                            imageLightboxIndex: e
                        },
                        i = r[c].dataset.imagelightbox;
                    i && (t.imageLightboxSet = i);
                    var n = a(M.location.search, "imageLightboxIndex", e);
                    i && (n = a(n, "imageLightboxSet", i)), D.history.pushState(t, "", n)
                }
            },
            t = function(e, t) {
                var i = e;
                if (i) {
                    var n = new RegExp("[?]" + t + "=[^&]*"),
                        a = new RegExp("&" + t + "=[^&]*");
                    i = (i = i.replace(n, "?")).replace(a, "")
                }
                return i
            },
            m = function(e) {
                var t = new RegExp("[?&]" + e + "(=([^&#]*)|&|#|$)").exec(M.location.search);
                if (t && t[2]) return decodeURIComponent(t[2].replace(/\+/g, " "))
            },
            v = function() {
                if (--c < 0) {
                    if (!0 === d.quitOnEnd) return L(), !1;
                    c = r.length - 1
                }
                l = r.eq(c), b(), _.trigger("previous.ilb2"), C(1)
            },
            x = function() {
                if (++c >= r.length) {
                    if (!0 === d.quitOnEnd) return L(), !1;
                    c = 0
                }
                b(), l = r.eq(c), _.trigger("next.ilb2"), C(-1)
            },
            y = function() {
                _.append(z)
            },
            w = function() {
                R(".imagelightbox-loading").remove()
            },
            E = function() {
                _.append(U)
            },
            q = function() {
                N.appendTo(_).on("click.ilb7", function() {
                    return L(), !1
                })
            },
            S = function() {
                j.html("&nbsp;"), R(l).data("ilb2-caption") ? j.html(R(l).data("ilb2-caption")) : 0 < j.html(R(l).data("ilb2-caption"))
            },
            k = function() {
                if (r.length) {
                    for (var e = 0; e < r.length; e++) Y.append(K.clone());
                    var t = Y.children("a");
                    t.eq(r.index(l)).addClass("active"), _.on("previous.ilb2 next.ilb2", function() {
                        t.removeClass("active").eq(r.index(l)).addClass("active")
                    }), _.append(Y), Y.on("click.ilb7 touchend.ilb7", function() {
                        return !1
                    }).on("click.ilb7 touchend.ilb7", "a", function() {
                        var e = R(this);
                        if (r.eq(e.index()).attr("href") !== R(".imagelightbox").attr("src")) {
                            var t = r.eq(e.index());
                            t.length && (n = r.index(l), l = t, C(e.index() < n ? -1 : 1))
                        }
                        e.addClass("active").siblings().removeClass("active")
                    })
                }
            },
            I = function() {
                _.append(X), X.on("click.ilb7 touchend.ilb7", function(e) {
                    return e.stopImmediatePropagation(), e.preventDefault(), R(this).hasClass("imagelightbox-arrow-left") ? v() : x(), !1
                })
            },
            O = function() {
                if (!u.length) return !0;
                var e = d.caption ? j.outerHeight() : 0,
                    a = R(D).width(),
                    o = R(D).height() - e,
                    r = Math.abs(1 - d.gutter / 100),
                    l = new Image;
                l.src = u.attr("src"), l.onload = function() {
                    if (g = l.width, f = l.height, a < g || o < f) {
                        var e = a / o < g / f ? g / a : f / o;
                        g /= e, f /= e
                    }
                    var t = f * r,
                        i = g * r,
                        n = (R(D).width() - i) / 2;
                    u.css({
                        width: i + "px",
                        height: t + "px",
                        left: n + "px"
                    })
                }
            },
            C = function(a) {
                if (p) return !1;
                if (u.length) {
                    var e = {
                        opacity: 0
                    };
                    B ? H(u, 100 * a - o + "px", d.animationSpeed / 1e3) : e.left = parseInt(u.css("left")) + 100 * a + "px", u.animate(e, d.animationSpeed, function() {
                        T()
                    }), o = 0
                }
                p = !0, d.activity && y(), d.caption && S(), setTimeout(function() {
                    var e = l.attr("href"),
                        t = 0,
                        i = 0,
                        n = 0;
                    u = R("<img id='" + d.id + "' />").attr("src", e).on("load.ilb7", function() {
                        var e = {
                            opacity: 1
                        };
                        if (u.appendTo(_), O(), u.css("opacity", 0), B) H(u, -100 * a + "px", 0), setTimeout(function() {
                            H(u, "0px", d.animationSpeed / 1e3)
                        }, 50);
                        else {
                            var t = parseInt(u.css("left"));
                            e.left = t + "px", u.css("left", t - 100 * a + "px")
                        }
                        if (u.animate(e, d.animationSpeed, function() {
                                p = !1, h()
                            }), d.preloadNext) {
                            var i = r.eq(r.index(l) + 1);
                            i.length || (i = r.eq(0)), R("<img />").attr("src", i.attr("href"))
                        }
                        _.trigger("loaded.ilb2")
                    }).on("error.ilb7", function() {
                        h()
                    }).on(W ? "pointerup.ilb7 MSPointerUp.ilb7" : "click.ilb7", function(e) {
                        return e.preventDefault(), d.quitOnImgClick ? (L(), !1) : !!A(e.originalEvent) || void((e.pageX || e.originalEvent.pageX) - e.target.offsetLeft < g / 2 ? v() : x())
                    }).on("touchstart.ilb7 pointerdown.ilb7 MSPointerDown.ilb7", function(e) {
                        if (!A(e.originalEvent) || d.quitOnImgClick) return !0;
                        B && (n = parseInt(u.css("left"))), t = e.originalEvent.pageX || e.originalEvent.touches[0].pageX
                    }).on("touchmove.ilb7 pointermove.ilb7 MSPointerMove.ilb7", function(e) {
                        if (!W && "pointermove" === e.type || !A(e.originalEvent) || d.quitOnImgClick) return !0;
                        e.preventDefault(), i = e.originalEvent.pageX || e.originalEvent.touches[0].pageX, o = t - i, B ? H(u, -o + "px", 0) : u.css("left", n - o + "px")
                    }).on("touchend.ilb7 touchcancel.ilb7 pointerup.ilb7 pointercancel.ilb7 MSPointerUp.ilb7 MSPointerCancel.ilb7", function(e) {
                        if (!A(e.originalEvent) || d.quitOnImgClick) return !0;
                        50 < Math.abs(o) ? o < 0 ? v() : x() : B ? H(u, "0px", d.animationSpeed / 1e3) : u.animate({
                            left: n + "px"
                        }, d.animationSpeed / 2)
                    })
                }, d.animationSpeed + 100)
            },
            T = function() {
                if (!u.length) return !1;
                u.remove(), u = R()
            },
            F = function(e, t) {
                if (p) return !1;
                p = !1, l = e, c = r.index(l), t || b(),
                    function() {
                        d.arrows && I(this), d.navigation && k(), d.overlay && E(), d.button && q(), d.caption && _.append(j)
                    }(), $.append(_).addClass("imagelightbox-open"), _.trigger("start.ilb2"), C(0)
            },
            L = function(e) {
                if (c = -1, e || function() {
                        if (J && d.history) {
                            var e = t(M.location.search, "imageLightboxIndex");
                            e = t(e, "imageLightboxSet"), D.history.pushState({}, "", e)
                        }
                    }(), _.trigger("quit.ilb2"), $.removeClass("imagelightbox-open"), !u.length) return !1;
                u.animate({
                    opacity: 0
                }, d.animationSpeed, function() {
                    T(), p = !1, r = R([]), _.remove().find("*").remove()
                })
            },
            P = function(t) {
                t.on("click.ilb7", {
                    set: i
                }, function(e) {
                    e.preventDefault(), i = R(e.currentTarget).data("imagelightbox"), t.filter(function() {
                        return R(this).data("imagelightbox") === i
                    }).filter(function() {
                        return e = R(this), "a" === R(e).prop("tagName").toLowerCase() && new RegExp(".(" + d.allowedTypes + ")$", "i").test(R(e).attr("href"));
                        var e
                    }).each(function() {
                        r = r.add(R(this))
                    }), r.length < 1 ? L() : F(R(this))
                })
            };
        return R(D).on("resize.ilb7", O), J && d.history && R(D).on("popstate", function(e) {
                var t = e.originalEvent.state;
                if (t) {
                    var i = t.imageLightboxIndex;
                    if (void 0 !== i) {
                        var n = s.filter('[data-ilb2-id="' + i + '"]');
                        if (0 < n.length) var a = s.index(n);
                        else n = R(s[a = i]);
                        if (n[0] && (!t.imageLightboxSet || t.imageLightboxSet === n[0].dataset.imagelightbox)) {
                            if (c < 0) return r = s, void F(n, !0);
                            var o = 1;
                            c < a && (o = -1), l = n, c = a, C(o)
                        }
                    } else L(!0)
                } else L(!0)
            }), R(M).ready(function() {
                d.quitOnDocClick && R(M).on(Q ? "touchend.ilb7" : "click.ilb7", function(e) {
                    u.length && !R(e.target).is(u) && (e.preventDefault(), L())
                }), d.fullscreen && G && R(M).on("keydown.ilb7", function(e) {
                    if (!u.length) return !0;
                    var t; - 1 < [9, 32, 38, 40].indexOf(e.which) && (e.stopPropagation(), e.preventDefault()), -1 < [13].indexOf(e.which) && (e.stopPropagation(), e.preventDefault(), (t = M.getElementById(d.id).parentElement).requestFullscreen ? t.requestFullscreen() : t.mozRequestFullScreen ? t.mozRequestFullScreen() : t.webkitRequestFullscreen ? t.webkitRequestFullscreen() : t.msRequestFullscreen && t.msRequestFullscreen(), M.exitFullscreen ? M.exitFullscreen() : M.mozCancelFullScreen ? M.mozCancelFullScreen() : M.webkitExitFullscreen && M.webkitExitFullscreen())
                }), d.enableKeyboard && R(M).on("keydown.ilb7", function(e) {
                    if (!u.length) return !0; - 1 < [27].indexOf(e.which) && d.quitOnEscKey && (e.stopPropagation(), e.preventDefault(), L()), -1 < [37].indexOf(e.which) && (e.stopPropagation(), e.preventDefault(), v()), -1 < [39].indexOf(e.which) && (e.stopPropagation(), e.preventDefault(), x())
                })
            }), R(M).off("click", d.selector), P(s),
            function() {
                if (J && d.history) {
                    var e = m("imageLightboxIndex");
                    if (e) {
                        var t = (r = s).filter('[data-ilb2-id="' + e + '"]');
                        0 < t.length ? c = r.index(t) : t = R(r[c = e]);
                        var i = m("imageLightboxSet");
                        !t[0] || i && i !== t[0].dataset.imagelightbox || F(t, !0)
                    }
                }
            }(), this.addToImageLightbox = function(e) {
                P(e)
            }, this.loadPreviousImage = function() {
                v()
            }, this.loadNextImage = function() {
                x()
            }, this.quitImageLightbox = function() {
                return L(), this
            }, this.startImageLightbox = function(e) {
                e ? e.trigger("click.ilb7") : R(this).trigger("click.ilb7")
            }, this
    }
});